var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M0.375308 2.1853C-0.091742 1.71825 -0.122879 0.981142 0.282055 0.478968L0.375115 0.375525C0.874439 -0.125079 1.68486 -0.125079 2.18527 0.375332L8.86493 7.05578L15.5454 0.375332C16.0125 -0.0917179 16.7496 -0.122854 17.2515 0.281765L17.3552 0.375139C17.8558 0.874463 17.8558 1.68489 17.3554 2.1853L10.674 8.86485L17.3552 15.5453C17.8224 16.0113 17.8536 16.7483 17.4488 17.2514L17.3554 17.3554C17.1123 17.5985 16.7873 17.7304 16.4504 17.7304C16.114 17.7304 15.7901 17.5988 15.5454 17.3554L8.86493 10.675L2.18489 17.3558C1.97576 17.5639 1.70722 17.6905 1.42332 17.7224L1.28029 17.7304C0.943368 17.7304 0.618367 17.5985 0.375308 17.3554C-0.125103 16.855 -0.125103 16.0446 0.375308 15.5455L7.0548 8.86485L0.375308 2.1853Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "accorCloseIcon",
    masktype: "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillrule: "evenodd",
    cliprule: "evenodd",
    d: "M0.375308 2.1853C-0.091742 1.71825 -0.122879 0.981142 0.282055 0.478968L0.375115 0.375525C0.874439 -0.125079 1.68486 -0.125079 2.18527 0.375332L8.86493 7.05578L15.5454 0.375332C16.0125 -0.0917179 16.7496 -0.122854 17.2515 0.281765L17.3552 0.375139C17.8558 0.874463 17.8558 1.68489 17.3554 2.1853L10.674 8.86485L17.3552 15.5453C17.8224 16.0113 17.8536 16.7483 17.4488 17.2514L17.3554 17.3554C17.1123 17.5985 16.7873 17.7304 16.4504 17.7304C16.114 17.7304 15.7901 17.5988 15.5454 17.3554L8.86493 10.675L2.18489 17.3558C1.97576 17.5639 1.70722 17.6905 1.42332 17.7224L1.28029 17.7304C0.943368 17.7304 0.618367 17.5985 0.375308 17.3554C-0.125103 16.855 -0.125103 16.0446 0.375308 15.5455L7.0548 8.86485L0.375308 2.1853Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#accorCloseIcon)"
  })));
};

export default __webpack_public_path__ + "static/media/AccorCloseIcon.8be020bb.svg";
export { SvgComponent as ReactComponent };